// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 590) return "static/css/590.d9f713f2b.chunk.css";
	if (chunkId === 570) return "static/css/570.d9f713f2b.chunk.css";
	// return url for filenames based on template
	return undefined;
};